import { UsableFaxWithExtensionPipe } from '../../../../../_helpers/_pipes/usable-fax-with-extension.pipe';
import { ViewableExtensionPipe } from '../../../../../_helpers/_pipes/viewable-extension.pipe';
import { ClaimsNeedHelpComponent } from '../claims-need-help/claims-need-help.component';
import { UploadDocumentsSidebarComponent } from '../upload-documents-sidebar/upload-documents-sidebar.component';
import { ArrorRightSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/arror-right-svg/arror-right-svg.component';
import { CliamsNavComponent } from '../cliams-nav/cliams-nav.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import 'rxjs/add/operator/filter';
import { GetAddressService } from '../../../../../_services/misc-services/get-address.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';


@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, CliamsNavComponent, ArrorRightSvgComponent, UploadDocumentsSidebarComponent, ClaimsNeedHelpComponent, ViewableExtensionPipe, UsableFaxWithExtensionPipe],
  selector: 'app-claims-detail',
  templateUrl: './claims-detail.component.html',
})
export class ClaimsDetailComponent implements OnInit {
  claims: any;
  claimid: string;
  loading: boolean;
  safeURL: SafeUrl;
  isAcmic: boolean;
  paymentStatus: string;
  company: string;
  // set claim exposures
  exposures: any = [];
  claim: any = {};

  constructor(
    private claimsDataService: ClaimsDataService,
    private activeRoute: ActivatedRoute,
    private getAddressService: GetAddressService,
    private acmicService: AcmicService,
    private companyTypeService: CompanyTypeService
  ) {
    this.isAcmic = false;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
    this.activeRoute.params.subscribe((params: Params) => {
      this.claimid = params['claimid'].split('-')[0];
      this.claimsDataService.$claimsLossDetails.subscribe((claimsList) => {
        const old_claims = {};
        const claim_list = [];
        if (Array.isArray(claimsList)) {
          claimsList.forEach((claim) => {
            if (old_claims[claim.number.number]) {
              return true;
            }
            old_claims[claim.number.number] = true;
            claim_list.push(claim);
          });
        }
        this.claims = claim_list;

        this.claims.forEach((claim) => {
          if (claim.number.number === this.claimid) {
            this.claim = claim;
            this.company = this.companyTypeService.getCompany(claim.policyNumber.policyNumber) ;
          }
          if (claim && claim.exposures) {
            claim.exposures.forEach((exposure) => {
              if (
                claim.number.number === this.claimid[0] &&
                exposure.exposureNumber.exposureNumber === this.claimid[1]
              ) {
                this.safeURL = this.getAddressService.getAddress(
                  exposure,
                  'claims'
                );
                exposure.paymentToDate = 0;
                exposure.payments.forEach((payment) => {
                  this.paymentStatus = payment.status.code.toLowerCase();
                  if (
                    this.paymentStatus === 'cashed' ||
                    this.paymentStatus === 'issued' ||
                    this.paymentStatus === 'cleared'
                  ) {
                    exposure.paymentToDate += parseFloat(payment.checkAmount);
                  }
                });
              }
            });
          }
        });

        this.loading = false;
      });
      // claimid[0] is the claimid while claimid[1] is the specific claim exposure id
    });
  }
}
